/** @file Field setter for a controlled form: set(key, value) calls onChange with a copy holding the value. */

/** Shared by the export field groups. */
export function formSetter<T extends object>(form: T, onChange: (next: T) => void): <K extends keyof T>(key: K, value: T[K]) => void {
  return (key, value) => { onChange({ ...form, [key]: value }); };
}
